/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('ServiceView', [
        "$sce", "ServiceData", "ServiceSrv", "Service", "HumanResourceSrv", "PhysicalResourceSrv", "$filter",
        "WidgetView", "StyleColor", "CurrencyManager", "NumberSeparatorType", "AppData", "ResourceSrv", "Resource", "BasicAuthRole", "Brand",
    function ($sce, ServiceData, ServiceSrv, Service, HumanResourceSrv, PhysicalResourceSrv, $filter, WidgetView,
              StyleColor, CurrencyManager, NumberSeparatorType, AppData, ResourceSrv, Resource, BasicAuthRole, Brand) {

        var ServiceView = function (service, servIndex, parentCategoryView, domainView, parentServiceView, position) {
                this.servIndex = servIndex;
                this.domainView = domainView;
                this.categoryType = "service";
                this.categoryTypeSortOrder = 0;
                this.label = "";
                this.previousLabelShort = "",
                this.labelShort = "";
                this.labelPosition = (position != null) ? String.fromCharCode(97 + position) : "";
                this.description = "";
                this.descriptionHtml = "";
                this.isPackage = false; // if the service is a package
                this.isOnHome = false; // if the service is on web home page -> offer
                this.homeOrder = 0;
                this.price = 0;
                this.hasInternetPrice = false; // if the service is on web home page
                this.hasMandatoryPayment = false;
                this.internetPrice = 0;
                this.internetPriceInput = $filter("currencyFormatFilter")(0);
                this.internetDiscountPercent = 0;
                this.duration = 30;//default
                this.hasItnDuration = false;
                this.itnDuration = 0;
                this.itnDurationD = 0;//internet duration displayed
                this.companyImage = null;
                this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
                this.specificImage = null;
                this.isSelected = false; //on selected
                this.isSmsSelected = false;
                this.isNotificationSelected = false;
                this.nbSelectableForCure = 0;
                this.nbSelectableForGift = 0;
                this.isVisibleOnWebSite = true;
                this.subServicesView = [];
                this.productsView = [];
                this.cureViews = [];
                this.imgWidgetView = null;
                this.subWidgetsView = null;
                this.styleView = {};  //styleView is an object and service.style is a string
                this.colorPicker = ""; //value liked by the colorpicker
                this.serviceId = "";
                this.serviceSettingsReserveWithGoogleId = null;
                this.displayMessageMultiStep = false;
                this.displayMessageNbHrsNeeded = false;
                this.displayMessageNbPrsNeeded = false;
                this.displayMessageDuration = false;
                this.displayMessagePrice = false;
                if (this.domainView && this.domainView.getHasHr !== undefined && this.domainView.getHasHr()) {
                    this.nbPrsNeeded = 0;
                    this.nbPrsNeededCheck = false;
                    this.nbHrsNeeded = 1;//default but depends type
                    this.nbHrsNeededCheck = true;
                } else {
                    this.nbPrsNeeded = 1;
                    this.nbPrsNeededCheck = true;
                    this.nbHrsNeeded = 0;//default but depends type
                    this.nbHrsNeededCheck = false;
                }
                //View parameters
                this.isSelResKnow = false; // if the selected Ressource know the service
                this.hrSkillsView = null;// [{ hrView, active (boolean }]
                this.prSkillsView = null;// [{ prView, active (boolean }]

                this.serviceSettings = {};
                this.serviceSettings[BasicAuthRole.GOOGLE_ROLE.role] = {
                    id : null,
                    view: null,
                    label: BasicAuthRole.GOOGLE_ROLE.label,
                    checkMultiStep : true,
                    checkNbHrsNeeded: true,
                    checkNbPrsNeeded: true,
                    checkDuration: true,
                    checkPrice : true
                };

                this.serviceSettings[BasicAuthRole.LE_CISEAU_ROLE.role] = {
                    id : null,
                    view: null,
                    label: Brand.marketplace.url.shortWebsite,
                    checkMultiStep : true,
                    checkNbHrsNeeded: true,
                    checkNbPrsNeeded: true,
                    checkDuration: true,
                    checkPrice : false
                };

                this.serviceSettingsActive = 0;

                this.isBookableOnWebSite = true;
                if (parentCategoryView !== undefined && parentCategoryView != null)
                    this.parentCategoryView = parentCategoryView;
                else
                    this.parentCategoryView = null;

                if (parentServiceView !== undefined && parentServiceView != null)
                    this.parentServiceView = parentServiceView;
                else
                    this.parentServiceView = null;

                this.styleView = this.getStyleFrom(service);
                if (this.styleView)
                    this.colorPicker = this.styleView.background;

                if (service) {
                    this.loadDataFrom(service);
                }
                this.isVisible = true;
                this.impactedByImport = false;
            };

        ServiceView.prototype.setSubServiceLabelPosition = function() {
            for (var i = 0;i < this.subServicesView.length;i++)
                this.subServicesView[i].labelPosition = String.fromCharCode(97 + i);
        };

        ServiceView.prototype.getModel = function() {
            if (this.servIndex!=-1)
            {
                return ServiceData.getByIndex(this.servIndex);
            }
            return null;
        };

        ServiceView.prototype.loadDataFrom = function(service) {
            //Assume here than the object in parameter contains only id (must load them)
            this.label = service.label;
            this.labelShort = service.labelShort;
            this.previousLabelShort = service.labelShort;
                this.description= service.description;
            if (this.description)
                this.description = this.description.replace(/(?:\r\n|\r|\n)/g, '<br />');
            this.isPackage = service.isPackage;
            this.isOnHome = service.isOnHome;
            this.homeOrder = service.homeOrder;
            this.hasInternetPrice = service.hasInternetPrice;
            this.hasMandatoryPayment = service.hasMandatoryPayment;
            this.isVisibleOnWebSite = service.isVisibleOnWebSite;
            this.isBookableOnWebSite = service.isBookableOnWebSite;
            this.serviceId = service.id;
            this.serviceSettingsReserveWithGoogleId = service.serviceSettingsReserveWithGoogleId;
            if (this.description)
                this.updateDescriptionHtml();

            this.price = service.price;
            // this.priceInput = $filter('currencyFormatFilter')(this.price);

            if (service.internetPrice!=null)
            {
                this.internetPrice= service.internetPrice;
                if (this.internetPrice==0 && this.price!=0)
                    this.internetDiscountPercent = 100;
                else if(this.price != 0) {
                    this.internetDiscountPercent = Math.round(10000 * (100 - 100 * this.internetPrice / this.price)) / 10000;
                }
            }
            else
                this.internetPrice = this.price;
            this.internetPriceInput = $filter('currencyFormatFilter')(this.internetPrice);
            this.duration= service.duration;
            if (service.itnDuration)
                this.itnDuration= service.itnDuration;
            this.hasItnDuration= service.hasItnDuration;
            if (this.hasItnDuration)
                this.itnDurationD = this.itnDuration;
            else
                this.itnDurationD = this.duration;
            this.specificImage = service.specificImage;
            this.image = service.image;
            this.companyImage = service.companyImage;
            if (this.image||this.companyImage)//for ascendencing compatibility
                this.specificImage = true;

            if (this.parentCategoryView && this.image==null && this.specificImage == false)
                this.image = this.parentCategoryView.image;

            if (this.parentCategoryView && this.companyImage==null && this.specificImage == false)
                this.companyImage = this.parentCategoryView.companyImage;

            if (this.companyImage)
                this.imageDisplayed = this.companyImage;
            else
                this.imageDisplayed = this.image;

            if (service.nbPrsNeeded !== undefined && service.nbPrsNeeded!=null)
            {
                this.nbPrsNeeded = service.nbPrsNeeded;
                this.nbPrsNeededCheck = this.nbPrsNeeded!=0;
            }
            if (service.nbHrsNeeded !== undefined && service.nbHrsNeeded!=null)
            {
                this.nbHrsNeeded = service.nbHrsNeeded;
                this.nbHrsNeededCheck = this.nbHrsNeeded!=0;
            }
            this.loadSubServicesView(service);
            this.initSubServicesPrice();
            this.updateSubServicesInternetVariables();
        };

        ServiceView.prototype.initSubServicesPrice = function() {
            var subServicePricesInitialised = false;
            for(var i = 0; i < this.subServicesView.length;i++)
            {
                if(this.subServicesView[i].price != 0){
                    subServicePricesInitialised = true;
                }
            }

            if(!subServicePricesInitialised && this.price != 0){
                this.updateSubServicesPrice();
            }
        };

        ServiceView.prototype.getDurationWithHR = function() {
            var totalDurationWithHR = 0;

            if (this.isPackage && this.subServicesView)
            {
                var subServiceWithHr = $filter('filter')(this.subServicesView, function (value, index, array)
                {
                    var retour = false;
                    if (value.nbHrsNeeded && value.nbHrsNeeded > 0)
                        retour = true;
                    return retour;
                });
                for (var i = 0; i < subServiceWithHr.length; i++)
                {
                    totalDurationWithHR += subServiceWithHr[i].duration;
                }
            }
            else
            {
                if(this.nbHrsNeeded && this.nbHrsNeeded > 0)
                {
                    totalDurationWithHR = this.duration;
                }
            }
            return totalDurationWithHR;
        };

        ServiceView.prototype.updateSubServicesPrice = function() {
            if (this.isPackage && this.subServicesView)
            {
                if (this.subServicesView)
                {
                    for (var i = 0; i < this.subServicesView.length; i++)
                    {
                        if(this.subServicesView[i].nbHrsNeeded)
                        {
                            this.subServicesView[i].price = (this.price / this.getDurationWithHR()) * this.subServicesView[i].duration;
                        }
                        else
                        {
                            this.subServicesView[i].price = 0;
                        }
                    }
                }
            }
        };

        ServiceView.prototype.updateSubServicesInternetVariables = function() {
            if (this.isPackage && this.subServicesView)
            {
                for (var i = 0; i < this.subServicesView.length; i++)
                {
                    this.subServicesView[i].internetDiscountPercent = this.internetDiscountPercent;
                    this.subServicesView[i].hasInternetPrice = this.hasInternetPrice;
                    if(this.subServicesView[i].hasInternetPrice && this.internetDiscountPercent != 100) {
                        if (this.subServicesView[i].nbHrsNeeded) {
                            this.subServicesView[i].internetPrice = this.subServicesView[i].price - this.subServicesView[i].price / 100 * this.internetDiscountPercent;
                        }
                        else {
                            this.subServicesView[i].internetPrice = 0;
                        }
                    }
                }
            }
        };

        ServiceView.prototype.updatePriceOnPackage = function() {
            if (this.isPackage && this.subServicesView)
            {
                var newPrice = 0;

                for (var i = 0; i < this.subServicesView.length; i++)
                {
                    newPrice += this.subServicesView[i].price;
                }
                this.price = newPrice;
                this.updateInternetDiscountPercent();
            }
        };

        ServiceView.prototype.updateDurationOnPackage = function() {
            if (this.isPackage)
            {
                this.duration =0;
                for (var i = 0;i<this.subServicesView.length;i++)
                    this.duration += this.subServicesView[i].duration;
            }
        };

        /*ServiceView.prototype.loadWidgetsView = function()
        {
            var service = this.getModel();
            if (service)
            {
                var widgetView=null;
                if (service.subWidgets)
                {
                    this.subWidgetsView = [];
                    var subWidgets =  JSON.parse(service.subWidgets);
                    if (subWidgets)
                    {
                        for (var i = 0;i<subWidgets.length;i++)
                        {
                            widgetView = new WidgetView(subWidgets[i],true,this.domainView);
                            this.subWidgetsView.push(widgetView);
                        }
                    }
                }
                if (service.imgWidget)
                {
                    var imgWidget =  JSON.parse(service.imgWidget);
                    if (imgWidget)
                        this.imgWidgetView = new WidgetView(imgWidget,-1,true,this.domainView);
                }
            }

        }*/
        ServiceView.prototype.onStyleViewChange = function() {
            var fontColor = StyleColor.getContrastYIQ(this.colorPicker);
            if (!this.styleView || this.styleView.background !=this.colorPicker)
            {
                if (!this.styleView ||//if undefined
                    (this.parentCategoryView && this.parentCategoryView.styleView===this.styleView ))// if same than parent : break inheritance
                    this.styleView = {};
                this.styleView.background  = this.colorPicker;
                this.styleView.color  = fontColor;
            }
            else{
                this.styleView.background = this.parentCategoryView.background;
                this.styleView.color = this.parentCategoryView.color;
            }
            if(this.subServicesView){
                for(var i = 0; i < this.subServicesView.length; i++){
                    this.subServicesView[i].styleView = {};
                    this.subServicesView[i].styleView.background = this.styleView.background;
                    this.subServicesView[i].styleView.color = this.styleView.color;
                }
            }
        };

        ServiceView.prototype.onGlobalPriceInputChange = function() {
            if(this.isPackage && this.subServicesView)
            {
                this.updateSubServicesPrice();
            }
            this.updateInternetDiscountPercent();
            this.checkActivePrice();
        };

        ServiceView.prototype.onGlobalPriceInputArrowClick = function(number) {
            this.updatePriceInputArrow(number);
            if(this.isPackage && this.subServicesView) {
                this.updateSubServicesPrice();
            }
            this.checkActivePrice();
        };

        ServiceView.prototype.onSubServicePriceInputChange = function() {
            if(this.parentServiceView)
                this.parentServiceView.updatePriceOnPackage();
        };

        ServiceView.prototype.onSubServicePriceInputArrowClick = function(number) {
            this.updatePriceInputArrow(number);
            if(this.parentServiceView)
                this.parentServiceView.updatePriceOnPackage();
        };

        ServiceView.prototype.onDurationInputChange = function() {
            this.updateDuration();
            this.updateSubServicesPrice();
        };

        ServiceView.prototype.onDurationServiceInputChange = function() {

            this.checkActiveDuration();

            if(!this.displayMessageDuration){
                this.onDurationInputChange();
            }else{
                this.duration = 1;
            }
        };

        ServiceView.prototype.updateDurationInputArrow = function(duration) {

            this.duration = duration;

            this.checkActiveDuration();

            if(!this.displayMessageDuration){
                this.onDurationInputChange();
            }
            else{
                this.duration = duration + 5;
            }
        };

        ServiceView.prototype.onSubServiceDurationInputChange = function() {
            this.updateDuration();
            this.parentServiceView.updateDurationOnPackage();
            this.parentServiceView.updateSubServicesPrice();
        };

        ServiceView.prototype.getStyleFrom = function(service) {
            var styleView = null;
            if (service)
                if (service.style && service.style.indexOf('{')!=0) //Previous type before 1.5 was not contains a jsonSTring
                    styleView = null;
                else
                    try {
                        styleView = angular.fromJson(service.style);
                    }
                    catch (ex) {
                        console.log("Error loading style")
                    }
            if (!styleView) {
                if (this.parentServiceView != null)
                    styleView = this.parentServiceView.styleView;
                else
                    if (this.parentCategoryView != null)
                        styleView = this.parentCategoryView.styleView;
                    else
                        styleView = {background: 'white'};
            }
            return styleView;
        };

        ServiceView.prototype.createImgWidgetView  = function() {
            if (!this.imgWidgetView)
            {
                this.imgWidgetView = new WidgetView(null,false,this.domainView);
                this.imgWidgetView.type= "object";
                this.imgWidgetView.object = this;
                this.imgWidgetView.objectType ="service";
                this.imgWidgetView.setImage(this.imageDisplayed.url,true);
            }
            return this.imgWidgetView;
        };

        ServiceView.prototype.createSubWidgetView  = function() {
            var widgetView=null;
            if (!this.subWidgetsView)
                this.subWidgetsView = [];
            widgetView = new WidgetView(null,false,this.domainView);
            widgetView.type= "object";
            widgetView.object = this;
            widgetView.objectType ="service";
            this.subWidgetsView.push(widgetView);
            return widgetView;
        };

        ServiceView.prototype.getSubServiceView  = function(service) {
            for (var j = 0; j < this.subServicesView.length; j++)
                if (this.subServicesView[j].getModel() === service)
                    return this.subServicesView[j];

            return null;
        };

        ServiceView.prototype.updateDescriptionHtml = function() {
            this.descriptionHtml = $sce.trustAsHtml(this.description.replace("\n","<br/>"));
        };

        ServiceView.prototype.onNbHrsNeededCheckChange = function() {
            this.nbHrsNeeded = this.nbHrsNeededCheck ? 1 : 0;
            const previousValue = this.nbHrsNeededCheck ? '0' : '1';
            this.manageResourceSkills(this.nbHrsNeeded, previousValue, this.hrSkillsView);
            if (this.parentServiceView) {
                this.parentServiceView.updateSubServicesPrice();
            }
        };

        ServiceView.prototype.onNbPrsNeededCheckChange = function() {
            this.nbPrsNeeded = this.nbPrsNeededCheck ? 1 : 0;
            const previousValue = this.nbPrsNeededCheck ? '0' : '1';
            this.manageResourceSkills(this.nbPrsNeeded, previousValue, this.prSkillsView);
        };

        ServiceView.prototype.onNbHrsNeededOptionInputChange = function(previousValue) {
            this.checkActiveNbHrsNeeded();
            if (!this.nbHrsNeeded) {
                this.nbHrsNeeded = 0;
            }
            this.manageResourceSkills(this.nbHrsNeeded, previousValue, this.hrSkillsView);
        };

        ServiceView.prototype.onNbPrsNeededOptionInputChange = function(previousValue) {
            this.checkActiveNbPrsNeeded();
            if (!this.nbPrsNeeded) {
                this.nbPrsNeeded = 0;
            }
            this.manageResourceSkills(this.nbPrsNeeded, previousValue, this.prSkillsView);
        };

        ServiceView.prototype.manageResourceSkills = function(newValue, previousValue, resourceSkillsView) {
            if (newValue === 0 && previousValue !== '0') {
                resourceSkillsView.forEach(resourceSkillView => resourceSkillView.active = false);
            } else if (newValue >= 1 && previousValue === '0') {
                resourceSkillsView.forEach(resourceSkillView => resourceSkillView.active = true);
            }
        };

        ServiceView.prototype.updateDuration = function() {
            if (this.duration!=null && typeof this.duration ==='string') {
                var durationStr = this.duration.replace(" ", "");
                var duration = parseInt(durationStr);
                if(!isNaN(duration))
                    this.duration = duration;
                else
                    this.duration = 0;
            }
        };

        ServiceView.prototype.updatePriceInputArrow = function(number) {
            if(this.price !== "NaN")
                this.price = this.price + number;

        };

        ServiceView.prototype.initInternetPrice = function() {
            if (this.hasInternetPrice && this.internetPrice==0)
            {
                this.internetPrice = this.price;
                this.internetPriceInput = $filter('currencyFormatFilter')(this.internetPrice);
                this.onInternetPriceInputChange();
            }
        };

        ServiceView.prototype.onHasInternetPriceInputChange = function() {
            this.updateSubServicesHasInternetPrice();
            this.initInternetPrice();
        };

        ServiceView.prototype.updateSubServicesHasInternetPrice = function() {
            for(var i =0; i < this.subServicesView.length;i++){
                this.subServicesView[i].hasInternetPrice = this.hasInternetPrice;
            }
        };

        ServiceView.prototype.updateInternetPriceInputArrow = function(number) {
            if (this.internetPriceInput!=null && typeof this.internetPriceInput ==='string') {
                var internetPriceStr = CurrencyManager.getPriceFromPriceInput(this.internetPriceInput);
                var internetPrice = parseFloat(internetPriceStr);
                if(internetPrice !== "NaN")
                    if ((internetPrice+number) < 0)
                        internetPrice = 0;
                    else
                        if ((internetPrice+number) < this.price)
                            internetPrice+= number;
                        else
                            internetPrice = this.price;

                this.internetPriceInput = $filter('currencyFormatFilter')(internetPrice);
                this.onInternetPriceInputChange();
            }
        };

        ServiceView.prototype.transformInternetPriceInNumber = function() {
            if (this.internetPriceInput!=null && typeof this.internetPriceInput ==='string') {
                var internetPriceStr = CurrencyManager.getPriceFromPriceInput(this.internetPriceInput);
                var internetPrice = parseFloat(internetPriceStr);
                if (internetPrice !== "NaN")
                    this.internetPrice = internetPrice;
                else
                    this.internetPrice = null;
            }
        };

        ServiceView.prototype.updateInternetDiscountPercent = function() {
            if (this.internetPrice==0 && this.price!=0)
                this.internetDiscountPercent = 100;
            else
                this.internetDiscountPercent = Math.round(100*(100- 100* this.internetPrice/this.price))/100;

        };

        ServiceView.prototype.onInternetPriceInputChange = function() {
            if (this.internetPriceInput!=null && typeof this.internetPriceInput ==='string') {
                this.transformInternetPriceInNumber();

               this.updateInternetDiscountPercent();

                if(this.isPackage && this.subServicesView)
                {
                    this.updateSubServicesInternetVariables();
                }
            }
        };

        ServiceView.prototype.loadSubServicesView = function(service) {
            if (service)
            {
                this.subServicesView = [];
                for (var j=0;j< service.subServices.length;j++)
                {
                    var serviceView  = new ServiceView(service.subServices[j], ServiceData.getIndexOf(service.subServices[j]),this.parentCategoryView,this.domainView, this, j);
                    this.subServicesView.push(serviceView);
                }
            }
        };

        ServiceView.prototype.loadProductsView = function() {
            var service = this.getModel();
            if (service)
            {
                this.productsView = [];
                var productView;
                for (var i = 0;i<service.products.length;i++)
                {
                    productView = this.domainView.getProductView(service.products[i]);
                    if (productView){
                        this.productsView.push(productView);
                    }
                }
            }
        };

        /**
         * Add the link between the service view and the cure view.
         *
         * @param cureView
         */
        ServiceView.prototype.addLinkToCureView = function(cureView) {
            let isCureLinkedToServiceView = this.cureViews.some( (element) => element == cureView);
            if (!isCureLinkedToServiceView) {
                this.cureViews.push(cureView);
            }

        };

        /**
         * Remove the link between the service view and the cure view.
         *
         * @param cureView
         */
        ServiceView.prototype.removeLinkToCureView = function(cureView) {
            this.cureViews = this.cureViews.filter( (element) => element !== cureView);
        };

        ServiceView.prototype.addProductViewOnService = function(productView) {
            if (productView && this.productsView.indexOf(productView)==-1)
                this.productsView.push(productView);
            this.updateDurationOnPackage();
        };

        ServiceView.prototype.removeProductViewOnService = function (productView) {
            var index = this.productsView.indexOf(productView);
            if (index != -1)
                this.productsView.splice(index, 1);
            this.updateDurationOnPackage();
        };

        ServiceView.prototype.hasSubServiceView = function(serviceView) {
            return (this.subServicesView.indexOf(serviceView)!=-1);
        };

        ServiceView.prototype.addSubServiceView = function(serviceView) {
            if (serviceView &&! this.hasSubServiceView(serviceView))
                this.subServicesView.push(serviceView);
            this.updateDurationOnPackage();
            this.updateSubServicesPrice();
        };

        ServiceView.prototype.onPackageChange = function() {
            this.subServicesView = [];
            if (this.isPackage) {
                this.createAndAddSubServiceView();
                this.createAndAddSubServiceView(); //call two times to have 2 steps by default when multi step is activated
            }
        };

        ServiceView.prototype.onPackageInputChange = function() {
            this.checkActiveMultiStep();

            if(!this.displayMessageMultiStep){
                this.onPackageChange();
            }else{
                this.isPackage = false;
            }

        };

        ServiceView.prototype.createAndAddSubServiceView = function() {
            var serviceView = new ServiceView(null,-1, this.parentCategoryView, this.domainView, this, this.subServicesView.length);
            if (this.domainView)
                serviceView.initSkills(this.domainView.getHumanResourcesView(),this.domainView.getPhysicalResourcesView());
            this.addSubServiceView(serviceView);
            return serviceView;
        };

        ServiceView.prototype.removeSubServiceView = function(serviceView) {
            if (serviceView)
            {
                var index = this.subServicesView.indexOf(serviceView);
                if (index!=-1)
                    this.subServicesView.splice(index,1);
                this.updateDurationOnPackage();
                this.updateSubServicesPrice();
            }
        };

        ServiceView.prototype.isChanged = function() {
            let service = this.getModel();
            if (service)
            {
                var image = service.image;
                if (image==null &&service.parentCategory&& service.specificImage== false)
                    image = service.parentCategory.image;
                var companyImage = service.companyImage;
                if (companyImage==null &&service.parentCategory&& service.specificImage== false)
                    companyImage = service.parentCategory.companyImage;

                var styleView  = this.getStyleFrom(service);
                var styleChanged = (this.styleView && !styleView) ||
                    !this.styleView && styleView ||
                    (this.styleView && styleView &&
                    this.styleView.background != styleView.background);

                let isServiceSettingsPartnerViewChanged = false;

                for (let serviceSettings in this.serviceSettings) {
                    if(this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view) {
                        isServiceSettingsPartnerViewChanged = isServiceSettingsPartnerViewChanged && this.serviceSettings[serviceSettings].view.isChanged(this.serviceSettings[serviceSettings].view.getModel());
                    }
                }

                return (
                    this.label != service.label ||
                    this.labelShort != service.labelShort ||
                    this.description!= service.description ||
                    this.isPackage!= service.isPackage ||
                    this.isOnHome!= service.isOnHome ||
                    this.hasInternetPrice!= service.hasInternetPrice ||
                    this.hasMandatoryPayment!= service.hasMandatoryPayment ||
                    this.price!= service.price ||
                    this.internetPrice!= service.internetPrice ||
                    this.duration!= service.duration ||
                    this.itnDuration!= service.itnDuration ||
                    this.hasItnDuration!= service.hasItnDuration ||
                    this.specificImage!= service.specificImage ||
                    this.image !== image ||
                    this.companyImage !== companyImage ||
                    this.nbHrsNeeded!= service.nbHrsNeeded ||
                    this.nbPrsNeeded!= service.nbPrsNeeded ||
                    this.hrSkillsIsChanged() ||
                    this.prSkillsIsChanged() ||
                    isServiceSettingsPartnerViewChanged
                    );
            }
            else
                return true;
        };

        ServiceView.prototype.setImage = function(image) {
            this.image = image;
            this.companyImage = null;
            this.imageDisplayed = this.image;
        };

        ServiceView.prototype.setCompanyImage = function(companyImage) {
            this.image = null;
            this.companyImage = companyImage;
            this.imageDisplayed = this.companyImage;
        };

        ServiceView.prototype.initSkills = function(humanResourcesView,physicalResourcesView) {
            if (this.isPackage) {
                for (var i = 0; i < this.subServicesView.length; i++)
                    this.subServicesView[i].initSkills(humanResourcesView,physicalResourcesView);
            }
            var service = this.getModel();
            this.hrSkillsView = [];
            for(var i=0;i<humanResourcesView.length;i++)
            {
                if (humanResourcesView[i].hasPlanning)
                {
                    var hr =  humanResourcesView[i].getModel();
                    var hrSkillView = {hrView : humanResourcesView[i]};
                    if (!service)
                        hrSkillView.active = true; //active by default for a new service
                    else
                        hrSkillView.active = hr && hr.hasService(service);
                    this.hrSkillsView.push(hrSkillView);
                }
            }
            this.prSkillsView = [];
            for(var i=0;i<physicalResourcesView.length;i++)
            {
                if (physicalResourcesView[i].hasPlanning)
                {
                    var pr =  physicalResourcesView[i].getModel();
                    var prSkillView = {prView : physicalResourcesView[i]};
                    prSkillView.active = pr && pr.hasService(service);
                    this.prSkillsView.push(prSkillView);
                }
            }
        };

        ServiceView.prototype.getClone = function(parentClone) {
            var clone = new ServiceView(null,-1,this.parentCategoryView,this.domainView, parentClone);
            clone.label = this.label;
            clone.labelShort = this.labelShort;
            clone.previousLabelShort = this.labelShort;
            clone.description = this.description;
            clone.isPackage = this.isPackage;
            clone.isOnHome = this.isOnHome;
            clone.homeOrder = this.homeOrder;
            clone.price= this.price;
            // clone.priceInput = this.priceInput ;
            clone.internetPriceInput = this.internetPriceInput ;
            clone.internetDiscountPercent = this.internetDiscountPercent ;
            clone.itnDurationD = this.itnDurationD;//internet duration displayed
            clone.hasInternetPrice = this.hasInternetPrice;
            clone.hasMandatoryPayment = this.hasMandatoryPayment;
            clone.internetPrice= this.internetPrice;
            clone.duration= this.duration;
            clone.itnDuration= this.itnDuration;
            clone.hasItnDuration= this.hasItnDuration;
            clone.image = this.image;
            clone.companyImage = this.companyImage;
            clone.specificImage = this.specificImage;
            clone.nbHrsNeeded = this.nbHrsNeeded;
            clone.nbPrsNeeded = this.nbPrsNeeded;
            clone.nbHrsNeededCheck = this.nbHrsNeededCheck;
            clone.nbPrsNeededCheck = this.nbPrsNeededCheck;
            clone.isVisibleOnWebSite = this.isVisibleOnWebSite;
            clone.displayMessageMultiStep = this.displayMessageMultiStep;
            clone.displayMessageNbHrsNeeded = this.displayMessageNbHrsNeeded;
            clone.displayMessageNbPrsNeeded = this.displayMessageNbPrsNeeded;
            clone.displayMessageDuration = this.displayMessageDuration;
            for (let serviceSettings in this.serviceSettings) {
                if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view) {
                    clone.serviceSettings[serviceSettings].view = this.serviceSettings[serviceSettings].view.getClone();
                }
            }

            clone.isBookableOnWebSite = this.isBookableOnWebSite;
            if(!parentClone) {
                clone.styleView = {};
                clone.styleView.background = this.styleView.background;
                clone.styleView.color = this.styleView.color;
                clone.colorPicker = this.colorPicker;
            }
            else{
                clone.styleView = parentClone.styleView;
            }

            clone.subServicesView = [];

            for (var i = 0;i<this.subServicesView.length;i++)
                clone.subServicesView.push(this.subServicesView[i].getClone(clone));

            clone.productsView = [];
            for (var i = 0; i < this.productsView.length; i++) {
                clone.productsView.push(this.productsView[i]);
            }
            if (this.hrSkillsView) {
                clone.hrSkillsView = this.hrSkillsView.slice(0);
            }
            if (this.prSkillsView) {
                clone.prSkillsView = this.prSkillsView.slice(0);
            }
            clone.isVisible = this.isVisible;
            return clone;
        };

        ServiceView.prototype.copyDataTo = function(service) {
            //Assume here than the object in parameter contains only id (must load them)
            service.label = this.label;
            service.labelShort = this.labelShort;
            service.description = this.description;
            service.isPackage = this.isPackage;
            service.isOnHome = this.isOnHome;
            service.homeOrder = this.homeOrder;
            service.price= this.price;
            service.hasInternetPrice = this.hasInternetPrice;
            service.hasMandatoryPayment = this.hasMandatoryPayment;
            service.internetPrice = this.internetPrice;
            service.duration = this.duration;
            service.itnDuration = this.itnDuration;
            service.hasItnDuration = this.hasItnDuration;
            service.image = this.image;
            service.companyImage = this.companyImage;
            service.specificImage = this.specificImage;
            service.nbHrsNeeded = this.nbHrsNeeded;
            service.nbPrsNeeded = this.nbPrsNeeded;
            service.isVisibleOnWebSite = this.isVisibleOnWebSite;
            service.isBookableOnWebSite = this.isBookableOnWebSite;
            service.subServices = [];
            var subService = null;

            for (var i = 0; i < this.subServicesView.length; i++) {
                subService = this.subServicesView[i].getModel();
                if (subService == null) {
                    subService = new Service();
                    this.subServicesView[i].servIndex = ServiceData.getIndexOf(subService);
                }
                this.subServicesView[i].copyDataTo(subService);
                service.subServices.push(subService);
            }
            service.products = [];
            var product =null;
            for (var i = 0; i < this.productsView.length; i++) {
                product =   this.productsView[i].getModel();
                if (product) {
                    service.products.push(product);
                }
            }

            if (this.imgWidgetView) {
                service.imgWidget= JSON.stringify(this.imgWidgetView.getObjectResource());
            }
            if (this.subWidgetsView) {
                var widgets = [];
                for (var i = 0; i < this.subWidgetsView.length; i++) {
                    widgets.push(this.subWidgetsView[i].getObjectResource());
                }
                service.subWidgets = JSON.stringify(widgets);
            }
            if (this.styleView) {
                service.style = angular.toJson(this.styleView);
            }
            service.isVisible = this.isVisible;
        };

        ServiceView.prototype.onSpecificImageChange = function() {
            if (!this.specificImage) {
                this.image = null;
                this.companyImage = null;
            }
        };

        ServiceView.prototype.updateModelAndCreateWithPartnerServiceSettings = function(activationByPartnerLabel, settingsByPartnerLabel, successFunction, errorFunction) {
            let service = this.updateModelWithoutSave();
            let serviceView = this;
            ServiceSrv.createWithPartnerServiceSettings(service, activationByPartnerLabel, settingsByPartnerLabel, function(data) {
                if (successFunction) {
                    successFunction();
                }
                serviceView.saveResourceSkills(data.id);
            }, errorFunction);
        };

        ServiceView.prototype.updateModel = function (successFunction, errorFunction) {
            let service = this.updateModelWithoutSave();
            let serviceView = this;
            ServiceSrv.save(service, function (data) {
                if (successFunction) {
                    successFunction(data);
                }
                serviceView.saveResourceSkills(data.id);
            }, errorFunction);
        };

        ServiceView.prototype.updateModelWithoutSave = function () {
            if (this.hasItnDuration) {
                this.itnDurationD = this.itnDuration;
            } else {
                this.itnDurationD = this.duration;
            }
            var service = this.getModel();
            if (service == null) {
                service = new Service();
                this.servIndex = ServiceData.getIndexOf(service);
            }

            if (!this.specificImage && this.parentCategoryView && this.parentCategoryView.parentCategoryView) {
                this.image = this.parentCategoryView.image;
                service.image = this.image;
            }

            this.copyDataTo(service);

            var category = this.parentCategoryView.getModel();
            if (category && category !== service.parentCategory) { // change of category
                if (service.parentCategory) {
                    service.parentCategory.removeService(service);
                }
                category.addService(service);
            }

            return service;
        };

        ServiceView.prototype.hrSkillsIsChanged = function() {
            var service = this.getModel();
            var previousActive;
            var isChanged = false;
            if (this.hrSkillsView) {
                var hr;
                for (var i = 0; i < this.hrSkillsView.length && !isChanged; i++) {
                    hr = this.hrSkillsView[i].hrView.getModel();
                    if (hr) {
                        previousActive = hr.hasService(service);
                        isChanged = previousActive != this.hrSkillsView[i].active//must update and save hr
                    }
                }
            }
            return isChanged;
        };

        ServiceView.prototype.prSkillsIsChanged = function() {
            var service = this.getModel();
            var previousActive;
            var isChanged = false;
            if (this.prSkillsView) {
                var pr;
                for (var i = 0; i < this.prSkillsView.length && !isChanged; i++) {
                    pr = this.prSkillsView[i].prView.getModel();
                    if (pr) {
                        previousActive = pr.hasService(service);
                        isChanged = previousActive != this.prSkillsView[i].active//must update and save pr
                    }
                }
            }
            return isChanged;
        };

        ServiceView.prototype.saveResourceSkills = function(serviceId) {
            if (this.isPackage) {
                if(this.hrSkillsView) {
                    for (let i = 0; i < this.hrSkillsView.length; i++) {
                        for (let j = 0; j < this.subServicesView.length && !this.hrSkillsView[i].active; j++) {
                            if (this.subServicesView[j].hrSkillsView) {
                                this.hrSkillsView[i].active = this.hrSkillsView[i].active || this.subServicesView[j].hrSkillsView[i].active;
                            }
                        }
                    }
                }
                if(this.prSkillsView) {
                    for (let i = 0; i < this.prSkillsView.length; i++) {
                        for (let j = 0; j < this.subServicesView.length && !this.prSkillsView[i].active; j++) {
                            if (this.subServicesView[j].prSkillsView) {
                                this.prSkillsView[i].active = this.prSkillsView[i].active || this.subServicesView[j].prSkillsView[i].active;
                            }
                        }
                    }
                }
            }
            this.saveResourceSkillsAction(serviceId);
        };

        ServiceView.prototype.saveResourceSkillsAction = function(serviceId) {
           let servicesViews = this.subServicesView.slice();
           servicesViews.push(this);
           let humanResources = [];
           let physicalResources = [];
           if(servicesViews) {
               for (let i = 0; i < servicesViews.length; i++) {
                   servicesViews[i].updateResourceModelSkills(humanResources, servicesViews[i].hrSkillsView, true);
                   servicesViews[i].updateResourceModelSkills(physicalResources, servicesViews[i].prSkillsView, false);
               }
           }
           if (humanResources.length > 0 || physicalResources.length > 0) {
               ResourceSrv.update(new Resource(humanResources, physicalResources, this.isPackage, serviceId));
           }
       };

        ServiceView.prototype.updateResourceModelSkills = function(resources, skillsView, isHumanResource) {
            let service = this.getModel();
            let previousActive;
            if (skillsView && service) {
                for (let i = 0; i < skillsView.length; i++) {
                    let resource = isHumanResource ? skillsView[i].hrView.getModel() : skillsView[i].prView.getModel()
                    if (resource) {
                        previousActive = resource.hasService(service);
                        if (previousActive !== skillsView[i].active) {
                            if (skillsView[i].active) {
                                resource.addService(service);
                            } else {
                                resource.removeService(service);
                            }
                            let index = this.findResource(resources, resource);
                            if(index !== -1) {
                                resources.splice(index, 1, resource);
                            } else {
                                resources.push(resource);
                            }
                        }
                    }
                }
            }
        };

        ServiceView.prototype.findResource = function(resources, resource) {
            let index;
            for (let i = 0; i < resources.length; i++) {
                 index = i;
                if (resource.id === resources[index].id) {
                    return index;
                }
            }
            return -1;
        };

        ServiceView.prototype.hasPrSkillsActive = function() {
            if (this.prSkillsView)
            for (var i = 0; i < this.prSkillsView.length; i++) {
                if (this.prSkillsView[i].active)
                    return true;
            }
            return false;
        };

        ServiceView.prototype.hasHrSkillsActive = function() {
            if (this.hrSkillsView)
                for (var i = 0; i < this.hrSkillsView.length; i++) {
                    if (this.hrSkillsView[i].active) {
                        return true;
                    }
                }
            return false;
        };

        ServiceView.prototype.removeModel = function() {
            var service = this.getModel();
            if (service!=null)
            {
                service.parentCategory.removeService(service);
                ServiceSrv.remove(service);
            }
        };

        ServiceView.prototype.reloadModel = function() {
            var service = this.getModel();
            if (service==null)
            {
                this.parentCategoryView.removeServiceView(this);
            }
            else
            {
                this.loadDataFrom(service);
            }
        };

        ServiceView.prototype.restoreModel = function() {   //undeleted
            var service = this.getModel();
            if (service)
            {
                if (service.parentCategory)
                    service.parentCategory.addService(service);
                ServiceSrv.restore(service);
            }

        };

        ServiceView.prototype.setSkills = function(resource) {
            this.isSelResKnow  = !resource || resource.hasService(this.getModel());
            return this.isSelResKnow;
        };

        ServiceView.prototype.canSave = function() {
            let canSave = true;
            if (this.isPackage) {
                canSave = this.subServicesView.length > 1;
                if(canSave) {
                    for (let i = 0; i < this.subServicesView.length; i++) {
                        canSave = canSave && this.subServicesView[i].canSave();
                    }
                }
            }
            let durationInt = parseInt(this.duration);
            if (isNaN(durationInt)) {
                this.duration = null;
            } else {
                this.duration = durationInt;
            }
            canSave = canSave && (this.duration != null
                && !!this.label
                && (!this.isPackage || !!this.labelShort)
                && (this.price >= 0) //prix (décimal)
                && (this.internetPrice >= 0 && //prix (décimal)) //durée (entier)
                    (!this.nbHrsNeeded > 0 || this.hasHrSkillsActive()) &&
                    (!this.nbPrsNeeded > 0 || this.hasPrSkillsActive()))
            );

            for (let serviceSettings in this.serviceSettings) {
                if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view && this.serviceSettings[serviceSettings].view.isVisibleOnPartner) {
                    canSave = canSave && this.serviceSettings[serviceSettings].view.canSave();
                }
            }

            return canSave;
        };

        ServiceView.prototype.search = function (searchedTextLC) {
            if (searchedTextLC && this.label.toLowerCase().indexOf(searchedTextLC)!=-1 || (this.image && this.image.keyWords && this.image.keyWords.indexOf(searchedTextLC)!=-1)) {
                return true;
            }
            return false;
        };

        ServiceView.prototype.checkActiveMultiStep = function () {
            for (let serviceSettings in this.serviceSettings) {
                if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view && this.serviceSettings[serviceSettings].checkMultiStep) {
                    this.serviceSettings[serviceSettings].view.displayMessagePartnerServiceDuration = false;
                    this.serviceSettings[serviceSettings].view.displayMessagePartnerNbHrsNeeded = false;
                    this.serviceSettings[serviceSettings].view.displayMessagePartnerNbPrsNeeded = false;
                    if (this.serviceSettings[serviceSettings].view.isVisibleOnPartner) {
                        this.displayMessageMultiStep = true;
                        break;
                    } else {
                        this.serviceSettings[serviceSettings].view.displayMessagePartnerMultiStep = false;
                        this.displayMessageMultiStep = false;
                    }
                }

            }
        };

        ServiceView.prototype.checkActiveDuration = function () {
            for (let serviceSettings in this.serviceSettings) {
                if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view && this.serviceSettings[serviceSettings].checkDuration) {
                    if (this.serviceSettings[serviceSettings].view.isVisibleOnPartner && this.duration <= 0) {
                        this.displayMessageDuration = true;
                        break;
                    } else {
                        this.serviceSettings[serviceSettings].view.displayMessagePartnerServiceDuration = false;
                        this.displayMessageDuration = false;
                    }
                }
            }
        };

        ServiceView.prototype.checkActivePrice = function () {
            for (let serviceSettings in this.serviceSettings) {
                if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view && this.serviceSettings[serviceSettings].checkPrice) {
                    if (this.serviceSettings[serviceSettings].view.isVisibleOnPartner) {
                        if (!this.serviceSettings[serviceSettings].view.isPriceEnabled) {
                            if (this.price <= 0) {
                                this.displayMessagePrice = true;
                                this.price = 0;
                                this.serviceSettings[serviceSettings].view.displayMessagePartnerIsPriceEnabled = true;
                                break;
                            } else {
                                this.serviceSettings[serviceSettings].view.price = this.price;
                            }
                        } else {
                            this.displayMessagePrice = false;
                            this.serviceSettings[serviceSettings].view.displayMessagePartnerIsPriceEnabled = false;
                        }
                    } else {
                        this.serviceSettings[serviceSettings].view.displayMessagePartnerIsPriceEnabled = false;
                        this.displayMessagePrice = false;
                    }
                }
            }
        };

        ServiceView.prototype.checkActiveNbHrsNeeded = function () {
            for (let serviceSettings in this.serviceSettings) {
                if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view && this.serviceSettings[serviceSettings].checkNbHrsNeeded) {
                    if (this.serviceSettings[serviceSettings].view.isVisibleOnPartner) {
                        this.displayMessageNbHrsNeeded = true;
                        break;
                    } else {
                        this.serviceSettings[serviceSettings].view.displayMessagePartnerNbHrsNeeded = false;
                        this.displayMessageNbHrsNeeded = false;
                    }
                }
            }
        };

        ServiceView.prototype.checkActiveNbPrsNeeded = function () {
            for (let serviceSettings in this.serviceSettings) {
                if (this.serviceSettings.hasOwnProperty(serviceSettings) && this.serviceSettings[serviceSettings].view && this.serviceSettings[serviceSettings].checkNbPrsNeeded) {
                    if (this.serviceSettings[serviceSettings].view.isVisibleOnPartner) {
                        this.displayMessageNbPrsNeeded = true;
                        break;
                    } else {
                        this.serviceSettings[serviceSettings].view.displayMessagePartnerNbPrsNeeded = false;
                        this.displayMessageNbPrsNeeded = false;
                    }
                }
            }
        };

        ServiceView.prototype.initAlertMessagePaymentOnline = function () {
            let serviceSettings = this.serviceSettings[BasicAuthRole.GOOGLE_ROLE.role];
            if (serviceSettings.view) {
                serviceSettings.view.displayAlertMessagePaymentOnline = false;
                if (this.hasMandatoryPayment) {
                    serviceSettings.view.displayAlertMessagePaymentOnline = true;
                } else {
                    let webSiteApp = AppData.getAppByCode("webSite");
                    if (webSiteApp) {
                        if (webSiteApp.getAppAttribute("hasBookingPaymentMandatory") && webSiteApp.getAppAttribute("hasBookingPaymentMandatory").value === "true") {
                            serviceSettings.view.displayAlertMessagePaymentOnline = true;
                        } else if (webSiteApp.getAppAttribute("hasBookingPaymentOnAmount") && webSiteApp.getAppAttribute("hasBookingPaymentOnAmount").value === "true") {
                            let price = this.price;
                            if (this.hasInternetPrice) {
                                price = this.internetPrice;
                            }
                            if (webSiteApp.getAppAttribute("bookingPaymentOnAmount") && parseInt(webSiteApp.getAppAttribute("bookingPaymentOnAmount").value) <= price) {
                                serviceSettings.view.displayAlertMessagePaymentOnline = true;
                            }
                        }
                    }
                }
            }
        };

        ServiceView.prototype.checkActiveOption = function (serviceSettings) {
            if (serviceSettings.checkMultiStep) {
                this.checkMultiStepOnActivePartner(serviceSettings);
            }
            if (serviceSettings.checkNbHrsNeeded) {
                this.checkNbHrsNeededOnActivePartner(serviceSettings);
            }
            if (serviceSettings.checkNbPrsNeeded) {
                this.checkNbPrsNeededOnActivePartner(serviceSettings);
            }
            if (serviceSettings.checkDuration) {
                this.checkDurationOnActivePartner(serviceSettings);
            }
            if (serviceSettings.checkPrice) {
                this.checkPriceOnActivePartner(serviceSettings);
            }
        };

        ServiceView.prototype.onVisibleOnPartnerChange = function (serviceSettingsRole) {
            this.displayMessageNbHrsNeeded = false;
            this.displayMessageNbPrsNeeded = false;
            this.displayMessageMultiStep = false;
            this.displayMessageDuration = false;
            let serviceSettingsDisplayMessageNbHrsNeeded = [];
            let serviceSettingsDisplayMessageNbPrsNeeded = [];
            let serviceSettingsDisplayMessageDuration = [];
            let serviceSettingsDisplayMessagePartnerMultiStep = [];
            this.serviceSettingsActive = 0;

            for(let serviceSettings in this.serviceSettings) {
                if (this.serviceSettings.hasOwnProperty(serviceSettingsRole)) {
                    if (this.serviceSettings[serviceSettings].view && this.serviceSettings[serviceSettings].view.isVisibleOnPartner) {
                        this.serviceSettingsActive = this.serviceSettingsActive + 1;
                    }
                    this.checkActiveOption(this.serviceSettings[serviceSettings]);

                    if (this.serviceSettings[serviceSettings].view && (
                        this.serviceSettings[serviceSettings].view.displayMessagePartnerMultiStep ||
                        this.serviceSettings[serviceSettings].view.displayMessagePartnerServiceDuration ||
                        this.serviceSettings[serviceSettings].view.displayMessagePartnerNbHrsNeeded ||
                        this.serviceSettings[serviceSettings].view.displayMessagePartnerNbPrsNeeded)) {
                        this.serviceSettings[serviceSettings].view.isVisibleOnPartner = false;
                    }
                    else {
                        this.displayMessageNbHrsNeeded = serviceSettingsDisplayMessageNbHrsNeeded.push(this.displayMessageNbHrsNeeded);
                        this.displayMessageNbPrsNeeded = serviceSettingsDisplayMessageNbPrsNeeded.push(this.displayMessageNbPrsNeeded);
                        this.displayMessageDuration = serviceSettingsDisplayMessageDuration.push(this.displayMessageDuration);
                        this.displayMessagePartnerMultiStep = serviceSettingsDisplayMessagePartnerMultiStep.push(this.displayMessagePartnerMultiStep);
                    }
                }
            }

            this.displayMessageNbHrsNeeded = serviceSettingsDisplayMessageNbHrsNeeded.includes(true);
            this.displayMessageNbPrsNeeded = serviceSettingsDisplayMessageNbPrsNeeded.includes(true);
            this.displayMessageMultiStep = serviceSettingsDisplayMessageDuration.includes(true);
            this.displayMessageDuration = serviceSettingsDisplayMessagePartnerMultiStep.includes(true);
        };

        ServiceView.prototype.onPromoEnabledChange = function (serviceSettingRole) {
            let serviceSettings = this.serviceSettings[serviceSettingRole];
            if (serviceSettings.view.promoEnabled) {
                serviceSettings.view.isVisibleOnPartner = true;
            }
            this.onVisibleOnPartnerChange(serviceSettingRole);
            if(!serviceSettings.view.isVisibleOnPartner) {
                serviceSettings.view.promoEnabled = false;
            }
        };

        ServiceView.prototype.onPriceEnabledChange = function (serviceSettingRole) {
             let serviceSettings = this.serviceSettings[serviceSettingRole];
             serviceSettings.view.price = this.price;
             this.onVisibleOnPartnerChange(serviceSettingRole);
        };

        ServiceView.prototype.checkDurationOnActivePartner = function (serviceSettings) {
            if (serviceSettings.view) {
                if (serviceSettings.view.isVisibleOnPartner && serviceSettings.checkDuration) {
                    if (this.isPackage) {
                        serviceSettings.view.displayMessagePartnerServiceDuration = false;
                    } else {
                        if (this.duration <= 0) {
                            serviceSettings.view.displayMessagePartnerServiceDuration = true;
                        }
                    }
                } else {
                    this.displayMessageDuration = false;
                    serviceSettings.view.displayMessagePartnerServiceDuration = false;
                }
            }
        };

        ServiceView.prototype.checkMultiStepOnActivePartner = function (serviceSettings) {
            if (serviceSettings.view) {
                if (serviceSettings.view.isVisibleOnPartner && serviceSettings.checkMultiStep) {
                    if (this.isPackage) {
                        serviceSettings.view.displayMessagePartnerMultiStep = true;
                    }
                } else {
                    this.displayMessageMultiStep = false;
                    serviceSettings.view.displayMessagePartnerMultiStep = false;
                }
            }
        };

        ServiceView.prototype.checkNbHrsNeededOnActivePartner = function (serviceSettings) {
            if (serviceSettings.view) {
                if (serviceSettings.view.isVisibleOnPartner && serviceSettings.checkNbHrsNeeded) {
                    if (this.isPackage) {
                        serviceSettings.view.displayMessagePartnerNbHrsNeeded = false;
                    } else {
                        if (this.nbHrsNeeded !== 1) {
                            serviceSettings.view.displayMessagePartnerNbHrsNeeded = true;
                        }
                        if (this.nbHrsNeeded === 1) {
                            this.displayMessageNbHrsNeeded = true;
                        }
                    }
                } else {
                    this.displayMessageNbHrsNeeded = false;
                    serviceSettings.view.displayMessagePartnerNbHrsNeeded = false;
                }
            }
        };

        ServiceView.prototype.checkNbPrsNeededOnActivePartner = function (serviceSettings) {
            if (serviceSettings.view) {
                if (serviceSettings.view.isVisibleOnPartner && serviceSettings.checkNbPrsNeeded) {
                    if (this.isPackage) {
                        serviceSettings.view.displayMessagePartnerNbPrsNeeded = false;
                    } else {
                        if (this.nbPrsNeeded !== 0) {
                            serviceSettings.view.displayMessagePartnerNbPrsNeeded = true;
                        }
                        if (this.nbPrsNeeded === 0) {
                            this.displayMessageNbPrsNeeded = true;
                        }
                    }
                } else {
                    this.displayMessageNbPrsNeeded = false;
                    serviceSettings.view.displayMessagePartnerNbPrsNeeded = false;
                }
            }
        };

        ServiceView.prototype.checkPriceOnActivePartner = function (serviceSettings) {
            if (serviceSettings.view) {
                if(serviceSettings.view.isVisibleOnPartner && !serviceSettings.view.isPriceEnabled) {
                    if (this.price <= 0) {
                        serviceSettings.view.price = 0;
                        serviceSettings.view.displayMessagePartnerIsPriceEnabled = true;
                        this.displayMessagePrice = true;
                    } else {
                        serviceSettings.view.price = this.price;
                        serviceSettings.view.displayMessagePartnerIsPriceEnabled = false;
                        this.displayMessagePrice = false;
                    }
                } else {
                    serviceSettings.view.displayMessagePartnerIsPriceEnabled = false;
                    this.displayMessagePrice = false;
                    if (serviceSettings.view.isDisplayMessagePartnerPriceNotValid) {
                        serviceSettings.view.isDisplayMessagePartnerPriceNotValid();
                    }
                }
            }
        };

        ServiceView.prototype.updateMarketplaceVariantInLabel = function(previousVariantLabel, variantLabel) {
            if (variantLabel && previousVariantLabel) {
                this.label = this.label.replace(previousVariantLabel, variantLabel);
            } else if (!previousVariantLabel && variantLabel) {
                this.label = this.label + " - " + variantLabel;
            } else {
                this.label = this.label.replace(" - " + previousVariantLabel, "");
            }
        }

        ServiceView.prototype.updateSubServiceViewLabelShort = function() {
            this.labelShort = this.label;
        };

        return ServiceView;
    }
]);



// WEBPACK FOOTER //
// ./js/services/views/ServiceView.js